import useSWRImmutable from 'swr/immutable'
import BigNumber from 'bignumber.js'
import { BIG_ZERO } from './bigNumber'

export const useCakePrice = () => {
  return useSWRImmutable(
    ['zeal-usd-price'],
    async () => {
      const zeal = await (await fetch('https://api.kaspafinance.io/price?coin=zeal')).json()
      return (Number(zeal?.usd) / 2).toString() as string
    },
    {
      refreshInterval: 1_000 * 10,
    },
  )
}

// for migration to bignumber.js to avoid breaking changes
export const useCakePriceAsBN = () => {
  const { data } = useSWRImmutable(
    ['zeal-usd-price-bn'],
    async () => {
      const zeal = await (await fetch('https://api.kaspafinance.io/price?coin=zeal')).json()
      // return new BigNumber(zeal.price)
      return new BigNumber((Number(zeal?.usd) / 2).toString()) // mock price
    },
    {
      compare: (a, b) => {
        if (!a && !b) return true
        if (!a || !b) return false
        return a.eq(b)
      },
      refreshInterval: 1_000 * 10,
    },
  )

  return data ?? BIG_ZERO
}
